/* eslint-disable global-require */
module.exports = ['login._modal.html.m5', 'login._modal.html.m6', 'marketplace.classified.actions.message.modaleform.m1'];
